// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACySURBVHgB7ZNNCsIwEIXfmIKIWLPpz7Jbi3dTT9B6Er2CN/AIXbnxBNKFFRR0EWMSKFgVMcnWbzUzi4/3CAG+ECbT2TjJj5xnHK6EcV4oieTpZA1X/pIO1EqIUKqxEuK+sBEEJJqm3ldGpJPAg9NhR4GJRVhKiQKQFZG0SgTRazo7T/NSJ1M1V3CAtcP1XG8Ho0hXnfeHUXa71BtYwJ4XHxl7PbjK2Kejb803zAPEv/3+BxZ4TlFctqAQAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RevisionWorkspace_workspace__HorqT {
  position: fixed;
  text-align: left;
  top: 0;
  right: 0;
  width: 85%;
  height: 100vh;
  background: rgba(249, 249, 249, 1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 30px;
  animation: RevisionWorkspace_slideIn__8Tml\\+ 0.3s ease forwards;
}


.RevisionWorkspace_header__3g12b {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.RevisionWorkspace_backButton__SVfLU {
    display: flex;
    align-items: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    height: 16.2px;
    border: none;
    font-size: 16px;
    cursor: pointer;
}

.RevisionWorkspace_backText__hScp\\+ {
    font-weight: bold;
    font-size: 18px;
    padding-left: 25px;
}

.RevisionWorkspace_backIcon__ktc6F {
  margin-right: 8px;
  font-size: 22px;
}

@keyframes RevisionWorkspace_slideIn__8Tml\\+ {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.RevisionWorkspace_header__3g12b {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.RevisionWorkspace_header__3g12b h2 {
  font-size: 24px;
  font-weight: 600;
}
.RevisionWorkspace_workspace__HorqT {
  background: #f5f5f5;
  padding: 20px;
  font-family: "Inter", sans-serif;
  color: #222;
  border-radius: 12px;
  box-shadow: inset 0 0 3px #ddd;
}

/* Top buttons */
.RevisionWorkspace_topBar__lMI-D {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.RevisionWorkspace_btnPrimary__FRgdn {
  background: #111;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: 0.2s;
}

.RevisionWorkspace_btnPrimary__FRgdn:hover {
  background: #333;
}

.RevisionWorkspace_btnBlack__0HtT- {
  background: black;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  margin-left: auto;
  cursor: pointer;
  font-weight: 500;
}

.RevisionWorkspace_btnAdd__I0hJG {
  background: rgba(29, 135, 82, 1);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  margin-left: 10px;
  transition: 0.2s;
}

.RevisionWorkspace_btnAdd__I0hJG:hover {
  background: rgb(12, 105, 59);
}

/* Cards */
.RevisionWorkspace_cards__LvHVC {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.RevisionWorkspace_card__Zt-90 {
  background: white;
  border-radius: 10px;
  padding: 16px;
  flex: 1 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.RevisionWorkspace_card__Zt-90 h4 {
  font-size: 15px;
  color: #444;
  margin-bottom: 5px;
}

.RevisionWorkspace_card__Zt-90 p {
  font-size: 18px;
  font-weight: 600;
  margin: 4px 0;
}

.RevisionWorkspace_red__3T3A5 {
  color: #e74c3c;
}

.RevisionWorkspace_orange__6EUS0 {
  color: #e67e22;
}

.RevisionWorkspace_green__d5u4B {
  color: #27ae60;
}

.RevisionWorkspace_blue__KleAj {
  color: #2980b9;
}

/* Tabs */
.RevisionWorkspace_tabs__x9QnV {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  border-bottom: 1px solid #ccc;
}

.RevisionWorkspace_tab__s7zwi {
  padding: 6px 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #555;
  font-weight: 500;
  border-bottom: 2px solid transparent;
}

.RevisionWorkspace_activeTab__6oTiv {
  color: black;
  border-bottom: 2px solid black;
}

/* Search + buttons */
.RevisionWorkspace_searchBar__T3gru {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.RevisionWorkspace_searchInput__FWcXw {
  flex: 1 1;
  padding: 8px 12px;
  border-radius: 6px;
  background-color: white;
  border: 1px solid #ccc;
  font-size: 14px;
}

/* Table */
.RevisionWorkspace_table__XfR14 table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.RevisionWorkspace_table__XfR14 th,
.RevisionWorkspace_table__XfR14 td {
  padding: 10px 14px;
  border-bottom: 1px solid #eee;
  text-align: left;
}

.RevisionWorkspace_table__XfR14 th {
  background: #fafafa;
  font-weight: 600;
  color: #444;
}

.RevisionWorkspace_table__XfR14 tr:hover {
  background: #f9f9f9;
}

.RevisionWorkspace_empty__CVU89 {
  text-align: center;
  padding: 20px;
  color: #888;
  font-style: italic;
}

.RevisionWorkspace_revisionInfoWrapper__\\+\\+gJa {
  margin-top: 10px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  padding: 15px;
}

.RevisionWorkspace_revisionInfoTable__S3bDk {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.RevisionWorkspace_revisionInfoTable__S3bDk th {
  text-align: left;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-weight: 600;
  color: #333;
}

.RevisionWorkspace_revisionInfoTable__S3bDk td {
  padding: 10px;
  border-bottom: 1px solid #f1f1f1;
  color: #555;
}

.RevisionWorkspace_notFinished__QeGs6 {
  color: #d9534f;
  font-weight: 500;
}


.RevisionWorkspace_suggestionList__uo0pl {
  top: 30px;
  position: absolute;
  background: #fff;
  border: 1px solid #ccc;
  width: 73.1%;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  margin-top: 5px;
  padding: 0;
  list-style: none;
}

.RevisionWorkspace_suggestionItem__msB6t {
  padding: 10px;
  cursor: pointer;
}

.RevisionWorkspace_suggestionItem__msB6t:hover {
  background-color: #f0f0f0;
}


`, "",{"version":3,"sources":["webpack://./src/styles/RevisionWorkspace.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,+DAAqC;AACvC;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yDAAya;IACza,4BAA4B;IAC5B,wBAAwB;IACxB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,SAAO;EACP,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".workspace {\n  position: fixed;\n  text-align: left;\n  top: 0;\n  right: 0;\n  width: 85%;\n  height: 100vh;\n  background: rgba(249, 249, 249, 1);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  padding: 30px;\n  animation: slideIn 0.3s ease forwards;\n}\n\n\n.header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.backButton {\n    display: flex;\n    align-items: center;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACySURBVHgB7ZNNCsIwEIXfmIKIWLPpz7Jbi3dTT9B6Er2CN/AIXbnxBNKFFRR0EWMSKFgVMcnWbzUzi4/3CAG+ECbT2TjJj5xnHK6EcV4oieTpZA1X/pIO1EqIUKqxEuK+sBEEJJqm3ldGpJPAg9NhR4GJRVhKiQKQFZG0SgTRazo7T/NSJ1M1V3CAtcP1XG8Ho0hXnfeHUXa71BtYwJ4XHxl7PbjK2Kejb803zAPEv/3+BxZ4TlFctqAQAAAAAElFTkSuQmCC);\n    background-repeat: no-repeat;\n    background-size: contain;\n    height: 16.2px;\n    border: none;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.backText {\n    font-weight: bold;\n    font-size: 18px;\n    padding-left: 25px;\n}\n\n.backIcon {\n  margin-right: 8px;\n  font-size: 22px;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.header h2 {\n  font-size: 24px;\n  font-weight: 600;\n}\n.workspace {\n  background: #f5f5f5;\n  padding: 20px;\n  font-family: \"Inter\", sans-serif;\n  color: #222;\n  border-radius: 12px;\n  box-shadow: inset 0 0 3px #ddd;\n}\n\n/* Top buttons */\n.topBar {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.btnPrimary {\n  background: #111;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: 0.2s;\n}\n\n.btnPrimary:hover {\n  background: #333;\n}\n\n.btnBlack {\n  background: black;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  margin-left: auto;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.btnAdd {\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-left: 10px;\n  transition: 0.2s;\n}\n\n.btnAdd:hover {\n  background: rgb(12, 105, 59);\n}\n\n/* Cards */\n.cards {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.card {\n  background: white;\n  border-radius: 10px;\n  padding: 16px;\n  flex: 1;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.card h4 {\n  font-size: 15px;\n  color: #444;\n  margin-bottom: 5px;\n}\n\n.card p {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 4px 0;\n}\n\n.red {\n  color: #e74c3c;\n}\n\n.orange {\n  color: #e67e22;\n}\n\n.green {\n  color: #27ae60;\n}\n\n.blue {\n  color: #2980b9;\n}\n\n/* Tabs */\n.tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #ccc;\n}\n\n.tab {\n  padding: 6px 12px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #555;\n  font-weight: 500;\n  border-bottom: 2px solid transparent;\n}\n\n.activeTab {\n  color: black;\n  border-bottom: 2px solid black;\n}\n\n/* Search + buttons */\n.searchBar {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.searchInput {\n  flex: 1;\n  padding: 8px 12px;\n  border-radius: 6px;\n  background-color: white;\n  border: 1px solid #ccc;\n  font-size: 14px;\n}\n\n/* Table */\n.table table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.table th,\n.table td {\n  padding: 10px 14px;\n  border-bottom: 1px solid #eee;\n  text-align: left;\n}\n\n.table th {\n  background: #fafafa;\n  font-weight: 600;\n  color: #444;\n}\n\n.table tr:hover {\n  background: #f9f9f9;\n}\n\n.empty {\n  text-align: center;\n  padding: 20px;\n  color: #888;\n  font-style: italic;\n}\n\n.revisionInfoWrapper {\n  margin-top: 10px;\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid #e0e0e0;\n  padding: 15px;\n}\n\n.revisionInfoTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.revisionInfoTable th {\n  text-align: left;\n  padding: 10px;\n  border-bottom: 1px solid #ddd;\n  font-weight: 600;\n  color: #333;\n}\n\n.revisionInfoTable td {\n  padding: 10px;\n  border-bottom: 1px solid #f1f1f1;\n  color: #555;\n}\n\n.notFinished {\n  color: #d9534f;\n  font-weight: 500;\n}\n\n\n.suggestionList {\n  top: 30px;\n  position: absolute;\n  background: #fff;\n  border: 1px solid #ccc;\n  width: 73.1%;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n  margin-top: 5px;\n  padding: 0;\n  list-style: none;\n}\n\n.suggestionItem {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.suggestionItem:hover {\n  background-color: #f0f0f0;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"workspace": `RevisionWorkspace_workspace__HorqT`,
	"slideIn": `RevisionWorkspace_slideIn__8Tml+`,
	"header": `RevisionWorkspace_header__3g12b`,
	"backButton": `RevisionWorkspace_backButton__SVfLU`,
	"backText": `RevisionWorkspace_backText__hScp+`,
	"backIcon": `RevisionWorkspace_backIcon__ktc6F`,
	"topBar": `RevisionWorkspace_topBar__lMI-D`,
	"btnPrimary": `RevisionWorkspace_btnPrimary__FRgdn`,
	"btnBlack": `RevisionWorkspace_btnBlack__0HtT-`,
	"btnAdd": `RevisionWorkspace_btnAdd__I0hJG`,
	"cards": `RevisionWorkspace_cards__LvHVC`,
	"card": `RevisionWorkspace_card__Zt-90`,
	"red": `RevisionWorkspace_red__3T3A5`,
	"orange": `RevisionWorkspace_orange__6EUS0`,
	"green": `RevisionWorkspace_green__d5u4B`,
	"blue": `RevisionWorkspace_blue__KleAj`,
	"tabs": `RevisionWorkspace_tabs__x9QnV`,
	"tab": `RevisionWorkspace_tab__s7zwi`,
	"activeTab": `RevisionWorkspace_activeTab__6oTiv`,
	"searchBar": `RevisionWorkspace_searchBar__T3gru`,
	"searchInput": `RevisionWorkspace_searchInput__FWcXw`,
	"table": `RevisionWorkspace_table__XfR14`,
	"empty": `RevisionWorkspace_empty__CVU89`,
	"revisionInfoWrapper": `RevisionWorkspace_revisionInfoWrapper__++gJa`,
	"revisionInfoTable": `RevisionWorkspace_revisionInfoTable__S3bDk`,
	"notFinished": `RevisionWorkspace_notFinished__QeGs6`,
	"suggestionList": `RevisionWorkspace_suggestionList__uo0pl`,
	"suggestionItem": `RevisionWorkspace_suggestionItem__msB6t`
};
export default ___CSS_LOADER_EXPORT___;
